module.exports = __webpack_public_path__ + "img/Background3.9bf0d7ef.jpg";